import React from "react";
import { isAndroid } from "react-device-detect";

/**
 * Construye la URL que se carga en el iframe del visor.
 *
 * Android (Samsung Internet / WebView de Android) no incluye un visor de PDF
 * nativo, por lo que `<iframe src=archivo.pdf>` muestra un ícono de archivo roto.
 * En ese caso se delega el render a Google Docs Viewer. En escritorio e iOS el
 * visor nativo del navegador funciona bien, así que se usa la URL directa.
 *
 * @param {string} url - URL firmada de S3 (puede incluir cache-buster `#t=...`).
 * @param {boolean} android - true si el dispositivo es Android.
 * @returns {string} URL lista para el atributo `src` del iframe.
 */
export const buildScannedPdfSrc = (url, android) => {
  if (!url) return url;
  // El fragmento (#t=...) no se envía al servidor y rompería el parámetro `url`
  // de Google Docs Viewer, así que se retira antes de delegar.
  const directUrl = url.split("#")[0];
  return android
    ? `https://docs.google.com/viewer?url=${encodeURIComponent(
        directUrl,
      )}&embedded=true`
    : url;
};

/**
 * Visor de PDF escaneado multiplataforma.
 *
 * Renderiza el PDF embebido (nativo en escritorio/iOS, Google Docs Viewer en
 * Android) y siempre ofrece un botón "Abrir en nueva pestaña" como alternativa
 * universal por si la previsualización embebida falla.
 */
const ScannedPdfViewer = ({
  url,
  title = "Reporte Escaneado",
  className,
  style,
}) => {
  if (!url) return null;

  const directUrl = url.split("#")[0];
  const src = buildScannedPdfSrc(url, isAndroid);

  return (
    <div className="scanned-pdf-viewer" style={{ width: "100%" }}>
      <iframe src={src} className={className} title={title} style={style} />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "8px",
        }}
      >
        <a
          href={directUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "8px 16px",
            borderRadius: "8px",
            background: "#667eea",
            color: "#fff",
            textDecoration: "none",
            fontWeight: 600,
          }}
        >
          <i className="fa-solid fa-up-right-from-square"></i>
          Abrir en nueva pestaña
        </a>
      </div>
    </div>
  );
};

export default ScannedPdfViewer;
